import { render, staticRenderFns } from "./Select-Customer-Property.vue?vue&type=template&id=572850d2&scoped=true"
import script from "./Select-Customer-Property.vue?vue&type=script&lang=js"
export * from "./Select-Customer-Property.vue?vue&type=script&lang=js"
import style0 from "./Select-Customer-Property.vue?vue&type=style&index=0&id=572850d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572850d2",
  null
  
)

export default component.exports